var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2381 0V7.61905H10.6667L16.7619 13.7143L22.8571 7.61905H18.2857V0H15.2381ZM5.18095 1.52381H0V4.57143H3.2L8.22857 16.6095L6.4 19.5048C5.48571 21.0286 5.94286 23.0095 7.31429 23.9238C7.92381 24.2286 8.38095 24.381 8.99048 24.381H27.4286V21.3333H8.99048L8.8381 21.181L10.819 18.2857H22.2476C23.3143 18.2857 24.381 17.6762 24.8381 16.7619L31.0857 5.48571L28.4952 3.9619L22.0952 15.2381H10.9714L5.18095 1.52381ZM9.14286 25.9048C7.46667 25.9048 6.09524 27.2762 6.09524 28.9524C6.09524 30.6286 7.46667 32 9.14286 32C10.819 32 12.1905 30.6286 12.1905 28.9524C12.1905 27.2762 10.819 25.9048 9.14286 25.9048ZM24.381 25.9048C22.7048 25.9048 21.3333 27.2762 21.3333 28.9524C21.3333 30.6286 22.7048 32 24.381 32C26.0571 32 27.4286 30.6286 27.4286 28.9524C27.4286 27.2762 26.0571 25.9048 24.381 25.9048Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuy);
export default __webpack_public_path__ + "static/media/buy.55d4c5af825d76e5a003ab2e7cf7bc9e.svg";
export { ForwardRef as ReactComponent };